import { createReducer } from '@reduxjs/toolkit';

import { TYPES } from '../../common/constants';

const setSideBarDone = (collapseSideBar, { payload }) => {
  return payload
};


const initialState = false;

export default createReducer(initialState, {
  [TYPES.SET_SIDE_BAR]: setSideBarDone,
});
